import { t } from "i18next";
import { AddressInputInbuilt } from "../../components/AddressInputInbuilt";
import { formFields, STATUS_OPTIONS } from "./constants";
import { SimpleHeader } from "../MagazineEvents/Components";
import { SimpleTextCell } from "../EmployeeList/Components";
import FormItem from "../../components/FormItem";
import { TextFilter } from "../../components/Filters/TextFilter";
import { ClickableActionNameCell } from "../Controllers/Components";
import { ObjectStatusCell } from "./Components";
import SelectSimpleInbuilt from "../../components/SelectSimple/Filters/SelectSimpleInbuilt";

export const getColumns = ({ control, columnsFromStorage, writeSearchDataToSessionStorage }) =>
  [
    {
      id: formFields.status,
      label: t("tableHeader:completionProgress"),
      enableSorting: false,
      isVisible: true,
      size: "100px",
      RowCell: (props) => <ObjectStatusCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.status}`}
          input={(props) => (
            <SelectSimpleInbuilt
              {...props}
              options={STATUS_OPTIONS}
              label={t("tableHeader:completionProgress")}
              placeholder={t("tableHeader:completionProgress")}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="statusStorage"
              className="select-in-table small-light"
            />
          )}
        />
      ),
    },
    {
      id: formFields.name,
      numeric: false,
      enableSorting: false,
      size: "300px",
      isVisible: columnsFromStorage[formFields.name],
      RowCell: (props) => <ClickableActionNameCell {...props} />,
      HeaderCell: () => (
        <FormItem
          sx={{ width: "300px" }}
          control={control}
          name={`${formFields.searchParams}.${formFields.name}`}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:facilityName")}
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="facilityNameStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.integrationNumber,
      numeric: false,
      enableSorting: false,
      label: t("tableHeader:integrationNumber"),
      size: "200px",
      isVisible: columnsFromStorage[formFields.integrationNumber],
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.integrationNumber}`}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:integrationNumber")}
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="integrationNumberStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.address,
      numeric: false,
      enableSorting: false,
      isVisible: columnsFromStorage[formFields.address],
      clickable: false,
      size: "400px",
      HeaderCell: () => (
        <FormItem
          sx={{ width: "400px" }}
          control={control}
          placeholder={t("tableHeader:address")}
          name={`${formFields.searchParams}.${formFields.address}`}
          input={(props) => (
            <AddressInputInbuilt
              {...props}
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchAddressStorage"
            />
          )}
        />
      ),
    },
    {
      id: formFields.phoneNumber,
      numeric: false,
      enableSorting: false,
      size: "150px",
      isVisible: columnsFromStorage[formFields.phoneNumber],
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.phoneNumber}`}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:phoneNumber")}
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="phoneNumberStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: "tasks",
      numeric: false,
      enableSorting: false,
      mode: "diagram",
      label: t("tableHeader:tasks"),
      isVisible: columnsFromStorage["messages"],
      size: "78px",
      clickable: false,
      HeaderCell: () => <SimpleHeader name={t("tableHeader:message_fire")} />,
    },
  ].filter(({ isVisible }) => isVisible);
